import { SentimentWordConfig } from './types';

export const ptSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'apoiado',
        'apoio',
        'aprovado',
        'ativo',
        'bom',
        'boa',
        'calmo',
        'claro',
        'completo',
        'concluido',
        'confianca',
        'crescimento',
        'eficiente',
        'estavel',
        'excelente',
        'feliz',
        'forte',
        'genial',
        'melhora',
        'melhorado',
        'otimo',
        'perfeito',
        'positivo',
        'progresso',
        'pronto',
        'resolvido',
        'saudavel',
        'seguro',
        'solido',
        'sucesso',
        'tranquilo',
        'util',
        'vitoria',
        'alegria',
        'amor',
        'animado',
        'avanco',
        'conforto',
        'confiavel',
        'encantado',
        'energia',
        'esperanca',
        'favoravel',
        'ganho',
        'gentil',
        'leve',
        'maravilhoso',
        'melhor',
        'motivado',
        'orgulho',
        'protegido',
        'recompensa',
        'satisfeito',
        'sereno',
        'suave',
        'superado',
        'valor',
        'vencendo',
        'vitorioso',
        'conquista',
        'acolhedor',
        'agradavel',
        'ajuda',
        'alivio',
        'amavel',
        'animacao',
        'aplauso',
        'ascensao',
        'bemestar',
        'brilho',
        'carinho',
        'celebrou',
        'confiado',
        'consistente',
        'coragem',
        'encorajado',
        'encorajante',
        'equilibrado',
        'esperancoso',
        'estimado',
        'firme',
        'florescendo',
        'ganhador',
        'harmonia',
        'honesto',
        'leveza',
        'melhoria',
        'orgulhoso',
        'prazer',
        'promissor',
        'radiante',
        'recuperado',
        'reforco',
        'respeitado',
        'restaurado',
        'seguranca',
        'serenidade',
        'sorriso',
        'valioso',
        'vigor',
    ]),
    negativeWords: new Set([
        'ameaca',
        'ansioso',
        'atrasado',
        'atraso',
        'bloqueado',
        'caos',
        'crise',
        'defeito',
        'demora',
        'desastre',
        'dificil',
        'dor',
        'erro',
        'falha',
        'falhou',
        'fraco',
        'frustrado',
        'grave',
        'instavel',
        'inseguro',
        'lento',
        'odio',
        'pessimo',
        'perigo',
        'pior',
        'preocupado',
        'problema',
        'quebrado',
        'rejeitado',
        'regressao',
        'risco',
        'ruim',
        'terrivel',
        'urgente',
        'abalado',
        'alarme',
        'ameacador',
        'atolado',
        'caido',
        'colapso',
        'complicado',
        'danoso',
        'decepcao',
        'deprimido',
        'doloroso',
        'duro',
        'falhando',
        'fragil',
        'horrivel',
        'inquieto',
        'mal',
        'nervoso',
        'panico',
        'pendente',
        'perda',
        'pressao',
        'preocupacao',
        'rejeicao',
        'tenso',
        'toxico',
        'travado',
        'vulneravel',
        'vergonhoso',
        'critico',
        'instabilidade',
        'abatido',
        'agressivo',
        'alarmante',
        'amargo',
        'aperto',
        'arruinado',
        'assustador',
        'bloqueante',
        'colapsado',
        'danificado',
        'degradado',
        'demoralizado',
        'desanimado',
        'desconforto',
        'dolorido',
        'duvidoso',
        'esgotado',
        'estressante',
        'frieza',
        'hostil',
        'incerto',
        'irritante',
        'lamentavel',
        'malicioso',
        'obstaculo',
        'opressivo',
        'perigoso',
        'prejudicial',
        'pressionado',
        'quebra',
        'sombrio',
        'traumatico',
        'tristeza',
        'vermelho',
        'vulnerado',
    ]),
};
